var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlorou(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5823 7.28711C12.0029 7.28711 11.4838 7.55007 11.1379 7.96289V9.97504H12.1001C13.1388 9.97504 13.9839 9.12994 13.9839 8.09122V7.28711H12.5823Z",
    fill: "#009986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4248 8.54688V12.8004H3.8642L4.15712 12.0525V9.02353L3.8642 8.54688H3.4248Z",
    fill: "#D6FC7E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86426 8.54688H4.30365V12.8004H3.86426V8.54688Z",
    fill: "#90E36A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30859 10.5518C4.26987 10.5518 3.4248 11.3969 3.4248 12.4356V13.2397H4.82634C5.86506 13.2397 6.71013 12.3946 6.71013 11.3559V10.5518H5.30859Z",
    fill: "#00CC76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6985 5.24707V12.8008H11.1379L11.4308 11.8963V5.92016L11.1379 5.24707H10.6985Z",
    fill: "#D6FC7E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1379 5.24707H11.5773V12.8008H11.1379V5.24707Z",
    fill: "#90E36A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69356 10.5518H8.29199V11.3559C8.29199 12.3946 9.13706 13.2397 10.1758 13.2397H11.5773V12.4356C11.5773 11.3969 10.7323 10.5518 9.69356 10.5518Z",
    fill: "#00CC76"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2118 4.5568L13.6879 3.3587L13.7546 3.22331C14.1978 2.32496 14.0196 1.2455 13.3113 0.537228L12.7741 0L11.385 1.38918C11.2937 1.48039 11.2114 1.57785 11.138 1.68029C11.0647 1.57785 10.9824 1.48039 10.8911 1.38918L9.50193 2.92926e-05L8.96473 0.537228C8.2564 1.24553 8.07825 2.32496 8.52139 3.22331L8.58817 3.3587L11.0642 4.5568H11.2118Z",
    fill: "#FF7C48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3112 0.537228L12.774 0L11.3848 1.38918C11.2936 1.48039 11.2113 1.57785 11.1379 1.68029V4.5568H11.2118L13.6878 3.3587L13.7546 3.22331C14.1977 2.32496 14.0195 1.2455 13.3112 0.537228Z",
    fill: "#FF415B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24042 2.58984H7.27588V3.34955C7.27588 4.63814 8.32421 5.68646 9.61276 5.68646H11.1379L11.4309 4.68615L11.1379 3.56415C10.7133 2.97446 10.0209 2.58984 9.24042 2.58984Z",
    fill: "#FFB655"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0354 2.58984C12.2549 2.58984 11.5626 2.97446 11.1379 3.56412V5.68646H12.6631C13.9517 5.68646 15 4.63814 15 3.34955V2.58984H13.0354Z",
    fill: "#FF7C48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00219727 12.3613V14.9977H7.5011L7.79403 13.6795L7.5011 12.3613H0.00219727Z",
    fill: "#D6FC7E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50098 12.3613H14.9999V14.9977H7.50098V12.3613Z",
    fill: "#90E36A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93592 7.85661L6.41195 6.65851L6.47874 6.52311C6.92188 5.62477 6.74372 4.5453 6.03539 3.83703L5.49822 3.2998L4.10904 4.68898C4.01783 4.7802 3.93545 4.87766 3.86214 4.98009C3.78879 4.87766 3.70644 4.7802 3.6152 4.68898L2.22605 3.29983L1.68885 3.83703C0.980525 4.54533 0.802367 5.62477 1.24551 6.52311L1.31229 6.65851L3.78832 7.85661H3.93592Z",
    fill: "#FF7C48"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03532 3.83703L5.49815 3.2998L4.10897 4.68898C4.01775 4.7802 3.93538 4.87766 3.86206 4.98009V7.85661H3.93588L6.4119 6.65851L6.47869 6.52311C6.9218 5.62477 6.74364 4.54533 6.03532 3.83703Z",
    fill: "#FF415B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96454 5.88965H0V6.64935C0 7.93794 1.04833 8.98627 2.33688 8.98627H3.86207L4.15499 7.98595L3.86207 6.86395C3.43744 6.27429 2.74508 5.88965 1.96454 5.88965Z",
    fill: "#FFB655"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75955 5.88965C4.97905 5.88965 4.28669 6.27426 3.86206 6.86392V8.98627H5.38724C6.67583 8.98627 7.72416 7.93794 7.72416 6.64935V5.88965H5.75955Z",
    fill: "#FF7C48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlorou);
export default __webpack_public_path__ + "static/media/florou.a2075a927823b681c908fc257cd365ac.svg";
export { ForwardRef as ReactComponent };